import(/* webpackMode: "eager" */ "/vercel/path0/app/course-lists/page.tsx");
